import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import {
  FaTelegram,
  FaTwitter,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTiktok,
  FaYoutube,
} from 'react-icons/fa';
import './JoinCommunity.css';

export default function JoinCommunity() {
  return (
    <section className="community-section" id="community">
      <Container>
        <div className="community-container">
          <div className="community-header">
            <h2 className="community-title">Join our community</h2>
            <div className="community-title-underline"></div>
          </div>

          <Row className="social-links-container">
            <Col lg="4" md="6" sm="12" className="social-column">
              <a
                href="https://t.me/%2BQZpe_llZ28piMTZk"
                target="_blank"
                rel="noopener noreferrer"
                className="social-card"
              >
                <div className="social-icon-wrapper telegram">
                  <FaTelegram className="social-icon" />
                </div>
                <h3 className="social-title">Telegram chat</h3>
                <p className="social-description">
                  Join our Telegram community for updates and discussions
                </p>
              </a>
            </Col>

            <Col lg="4" md="6" sm="12" className="social-column">
              <a
                href="https://x.com/MCGPchain"
                target="_blank"
                rel="noopener noreferrer"
                className="social-card"
              >
                <div className="social-icon-wrapper twitter">
                  <FaTwitter className="social-icon" />
                </div>
                <h3 className="social-title">X (Twitter)</h3>
                <p className="social-description">
                  Follow us on X for the latest news and announcements
                </p>
              </a>
            </Col>

            <Col lg="4" md="6" sm="12" className="social-column">
              <a
                href="https://www.facebook.com/profile.php?id=61575573471209"
                target="_blank"
                rel="noopener noreferrer"
                className="social-card"
              >
                <div className="social-icon-wrapper facebook">
                  <FaFacebook className="social-icon" />
                </div>
                <h3 className="social-title">Facebook</h3>
                <p className="social-description">
                  Like our Facebook page for regular updates
                </p>
              </a>
            </Col>

            <Col lg="4" md="6" sm="12" className="social-column">
              <a
                href="https://www.instagram.com/mcgpchain"
                target="_blank"
                rel="noopener noreferrer"
                className="social-card"
              >
                <div className="social-icon-wrapper instagram">
                  <FaInstagram className="social-icon" />
                </div>
                <h3 className="social-title">Instagram</h3>
                <p className="social-description">
                  Follow our Instagram for visual updates and stories
                </p>
              </a>
            </Col>

            <Col lg="4" md="6" sm="12" className="social-column">
              <a
                href="https://www.linkedin.com/in/mcgpchain"
                target="_blank"
                rel="noopener noreferrer"
                className="social-card"
              >
                <div className="social-icon-wrapper linkedin">
                  <FaLinkedin className="social-icon" />
                </div>
                <h3 className="social-title">LinkedIn</h3>
                <p className="social-description">
                  Connect with us on LinkedIn for professional updates
                </p>
              </a>
            </Col>

            <Col lg="4" md="6" sm="12" className="social-column">
              <a
                href="https://www.tiktok.com/@mcgpchain?_t=ZM-8vYqUfaXqAo&_r=1"
                target="_blank"
                rel="noopener noreferrer"
                className="social-card"
              >
                <div className="social-icon-wrapper tiktok">
                  <FaTiktok className="social-icon" />
                </div>
                <h3 className="social-title">TikTok</h3>
                <p className="social-description">
                  Follow our TikTok for entertaining crypto content
                </p>
              </a>
            </Col>

            <Col lg="6" md="6" sm="12" className="social-column">
              <a
                href=" https://t.me/+vnIAFTD7U5Y5OWU0"
                target="_blank"
                rel="noopener noreferrer"
                className="social-card news-channel"
              >
                <div className="social-icon-wrapper telegram">
                  <FaTelegram className="social-icon" />
                </div>
                <h3 className="social-title">Telegram News Channel</h3>
                <p className="social-description">
                  Subscribe to our news channel for important announcements and
                  updates
                </p>
              </a>
            </Col>

            <Col lg="6" md="6" sm="12" className="social-column">
              <a
                href="https://www.youtube.com/@mcgpchain"
                target="_blank"
                rel="noopener noreferrer"
                className="social-card"
              >
                <div className="social-icon-wrapper youtube">
                  <FaYoutube className="social-icon" />
                </div>
                <h3 className="social-title">YouTube</h3>
                <p className="social-description">
                  Follow our YouTube channel for crypto education and insights
                </p>
              </a>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}
